import React from 'react';
import PasswordNew from 'components/molecules/password_new';
import Logo from 'assets/images/logo-conlicitacao-dark.png';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import PasswordEdit from 'components/molecules/password_edit';
import * as S from './styles';

interface PasswordsProps {
  params: {
    page?: string;
  };
}

const Passwords = (props: PasswordsProps) => {
  const { params } = props;
  const { profile, password_new } = useSelector<ApplicationState, ProfileState>(
    (state) => state.storage.profile,
  );

  return (
    <S.Body>
      <div className="login-bar text-white">
        <S.Container>
          <div className="row py-1">
            <div className="col-md-6 col-12">Tudo sobre licitações públicas</div>
            <div className="col-md-6 col-12 text-md-right text-left">
              {`Dúvidas? `}
              <a href="https://wa.me/5508001114133" target="_blank" rel="noopener noreferrer">
                Entre em contato
              </a>
              {` ou ligue 0800 11 14133`}
            </div>
          </div>
        </S.Container>
      </div>
      {!password_new.loading && profile?.password_message !== '' && (
        <div
          className={`alert  text-center ${password_new?.error ? 'alert-danger' : 'alert-info'}`}
          role="alert"
        >
          {profile?.password_message}
        </div>
      )}
      <div className="text-center my-3">
        <img src={Logo} alt="ConLicitação" className="my-3" style={{ width: '250px' }} />
      </div>
      {params?.page === 'new' ? <PasswordNew /> : <PasswordEdit />}
    </S.Body>
  );
};
export default Passwords;
